import React from "react";
// import "../ProductDetails/productCarousel.scss";
import ct from "class-types.macro";
import Carousel from "./ProductCarouselContainer";
import { CardCarouselModel } from "../Models/PageCreatorPage";

interface CardCarouselProps extends CardCarouselModel {
  couponCode: string;
}

const CardCarousel = ({
  imageUrl,
  title,
  imageAltText,
  products,
  couponCode,
  productListingUrl,
  includeShopAllButton,
  shopAllButtonColor,
}: CardCarouselProps) => {
  return (
    <>
      <div className="carousel-wrap mb-0">
        {includeShopAllButton && (
          <h3
            className={ct(
              "block",
              "font-bold",
              "text-2xl",
              "mb-2",
              "text-gray-900",
              "capitalize",
              "lt:hidden",
            )}
          >
            {title}
            <a
              className={ct(
                "block",
                "text-lg",
                "ml-0",
                "mt-2",
                "xs:inline-block",
                "xs:mt-0",
                "xs:ml-4",
              )}
              href={productListingUrl}
              style={{ color: shopAllButtonColor }}
            >
              Shop All &gt;
            </a>
          </h3>
        )}
        <div className="carousel-wrap mb-0 flex">
          <div style={{ width: "324px" }}>
            <a href={productListingUrl}>
              <img
                className={ct(
                  "hidden",
                  "float-left",
                  "h-full",
                  "w-full",
                  "lt:block",
                )}
                src={imageUrl}
                alt={imageAltText}
                style={{ objectPosition: "top left", objectFit: "cover" }}
              />
            </a>
          </div>
          <div className="card-carousel-container">
            <Carousel
              imageUrl={imageUrl}
              items={products}
              discountCode={couponCode}
              containerClassNames={ct("flex")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CardCarousel;
